import { SparklesIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

/** Marks a control or heading as KI-powered (same pictogram as Helpdesk AI). */
export function KiMark({ className }: { className?: string }) {
  return <SparklesIcon className={cn('size-4 shrink-0 text-primary', className)} aria-hidden />;
}
